import { render, staticRenderFns } from "./launcher.vue?vue&type=template&id=c241b3d4&scoped=true"
import script from "./launcher.vue?vue&type=script&lang=js"
export * from "./launcher.vue?vue&type=script&lang=js"
import style0 from "./launcher.vue?vue&type=style&index=0&id=c241b3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c241b3d4",
  null
  
)

export default component.exports